(() => {
  'use strict';
  const data = JSON.parse(document.getElementById('category-data').textContent);
  const $ = s => document.querySelector(s);
  const cards = [...document.querySelectorAll('.product-card')];
  const families = Object.fromEntries(data.products.map(f => [f.key, f]));
  const chosen = Object.fromEntries(data.products.map(f => [f.key, f.options[0]]));
  let expanded = false;
  function choose(index) {
    const c = data.finder[index];
    if (!c) return;
    document.querySelectorAll('[data-choice]').forEach((b,i) => b.setAttribute('aria-pressed', String(i === index)));
    $('#finder-image').src = c.product.image;
    $('#finder-image').alt = c.product.title;
    $('.finder-number').textContent = String(index + 1).padStart(2, '0');
    $('#finder-title').textContent = c.title;
    $('#finder-description').textContent = c.description;
    $('#finder-note-label').textContent = c.noteLabel;
    $('#finder-notes').textContent = c.note;
    $('#finder-shop').href = c.product.url;
    $('#finder-shop').textContent = `Shop ${c.product.shortName} · ${(Number.isFinite(c.product.price)?"$"+c.product.price.toFixed(2):"Unavailable")} ↗`;
  }
  document.querySelectorAll('[data-choice]').forEach(b => b.addEventListener('click', () => choose(Number(b.dataset.choice))));
  function filter() {
    const focused = document.activeElement;
    const group = $('#group-filter').value, stock = $('#stock-filter').checked, sort = $('#sort-filter').value;
    let matches = cards.filter(c => (group === 'all' || families[c.dataset.family].group === group) && (!stock || chosen[c.dataset.family].available));
    if (sort.startsWith('price')) matches.sort((a,b) => (chosen[a.dataset.family].price - chosen[b.dataset.family].price) * (sort === 'price-asc' ? 1 : -1));
    if (sort === 'name') matches.sort((a,b) => families[a.dataset.family].name.localeCompare(families[b.dataset.family].name));
    const visible = expanded ? matches : matches.slice(0, 8);
    const order = [...matches, ...cards.filter(c => !matches.includes(c))], grid = $('#product-grid');
    order.forEach((card,index) => { if (grid.children[index] !== card) grid.insertBefore(card, grid.children[index] || null); });
    cards.forEach(c => { const hidden = !visible.includes(c); if (c.hidden !== hidden) c.hidden = hidden; });
    $('#catalog-count').textContent = `Showing ${visible.length} of ${matches.length} ${matches.length === 1 ? 'choice' : 'choices'}`;
    $('#empty-state').hidden = matches.length > 0;
    $('#show-more').hidden = matches.length <= 8;
    $('#show-more').textContent = expanded ? 'Show fewer ↑' : `See all ${matches.length} choices ↓`;
    if (focused instanceof HTMLElement && focused.isConnected && !focused.closest('[hidden]') && document.activeElement !== focused) focused.focus({preventScroll:true});
    else if (focused instanceof HTMLElement && focused.closest('.product-card[hidden]')) $('#stock-filter').focus();
  }
  const form = $('#catalog-filters');
  form.addEventListener('submit', e => e.preventDefault());
  form.addEventListener('change', () => { expanded = false; filter(); });
  form.addEventListener('reset', () => requestAnimationFrame(() => { expanded = false; filter(); }));
  $('#clear-filters').addEventListener('click', () => { form.reset(); $('#group-filter').focus(); });
  $('#show-more').addEventListener('click', () => {
    expanded = !expanded; filter();
    if (expanded) [...$('#product-grid').children].filter(c=>!c.hidden)[8]?.querySelector('a')?.focus({preventScroll:true});
    else $('#shop').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  });
  document.querySelectorAll('[data-option]').forEach(select => select.addEventListener('change', () => {
    const card = select.closest('.product-card'), key = card.dataset.family;
    const p = families[key].options.find(p => p.optionId === select.value); chosen[key] = p;
    const img = card.querySelector('[data-product-image]'); img.src = p.image; img.alt = p.title;
    card.querySelectorAll('[data-product-link]').forEach(a => { a.href = p.url; if(a.classList.contains('product-photo')) a.setAttribute('aria-label',p.title); });
    card.querySelector('[data-price]').textContent = `${(Number.isFinite(p.price)?"$"+p.price.toFixed(2):"Unavailable")}`;
    card.querySelector('.sold-out').hidden = p.available;
    card.querySelector('.buy-link').innerHTML = `${p.available?'Shop this choice':'View product'} <span aria-hidden="true">↗</span>`;
    filter();
  }));
  filter();
})();
